import { createContext } from 'react';
export const cmnContext = createContext<any>(null);

